import { render, staticRenderFns } from "./defaultSeat.vue?vue&type=template&id=04decd88&scoped=true&"
import script from "./defaultSeat.vue?vue&type=script&lang=js&"
export * from "./defaultSeat.vue?vue&type=script&lang=js&"
import style0 from "./defaultSeat.vue?vue&type=style&index=0&id=04decd88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04decd88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04decd88')) {
      api.createRecord('04decd88', component.options)
    } else {
      api.reload('04decd88', component.options)
    }
    module.hot.accept("./defaultSeat.vue?vue&type=template&id=04decd88&scoped=true&", function () {
      api.rerender('04decd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/defaultSeat.vue"
export default component.exports